import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';

import { Job} from '../../models/job';
import { Store } from '@ngrx/store';
import { AppState,selectReportState } from '@app/store/app.states';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { SendPagesToStudio, SendManyPagesToStudio } from '@app/store/actions/project.actions';
import { ReportTypes } from '../../models/report';
import { DocumentSegment } from '../../models/documentSegment';
// import { listTransition } from '@app/core/animations/list-animations';

@Component({
  selector: 'send-to-studio-dialog',
  templateUrl: './send-to-studio-dialog.component.html',
  styleUrls: ['./send-to-studio-dialog.component.scss']
})
export class SendToStudioDialogComponent implements OnInit {

//  dialogFormGroup: FormGroup;
  success:boolean = false;
  complete:boolean = false; // for the svg pen display

  //@ViewChild('notifyForm') notifyForm;
  jobs:Job[];
  documentSegments:DocumentSegment[];
  selectedJob:Job;
  selectedDocumentSegment:DocumentSegment;

  reportType:string = ReportTypes.PAGE_POSITION;
  reportTypes:any = ReportTypes;

  constructor(
    public dialogRef: MatDialogRef<SendToStudioDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(DOCUMENT) private document: any,
    private fb: FormBuilder,
    private store: Store<AppState>

  ) {

    this.jobs = data.jobs;
    this.selectedJob = data.job;
    this.selectedDocumentSegment = data.documentSegment?data.documentSegment:null
    this.documentSegments = data.documentSegments?data.documentSegments:null;

    if(this.documentSegments)
      this.selectedJob = this.jobs[0];

    console.log(data);
  }

  ngOnInit() {
  }

  onSubmit(){

    this.success = true;
    let job = new Job();
    job.uuid = this.selectedJob.uuid;

    let ds = new DocumentSegment();
    if(this.selectedDocumentSegment){
      ds.uuid = this.selectedDocumentSegment.uuid;
    }
    const payload = {job:job,jobs:[job],pages:null};

    if(this.selectedDocumentSegment){
      // if this is a page report
      payload.pages = [this.selectedDocumentSegment.segmentNumber];
      this.store.dispatch(new SendPagesToStudio(payload));
    }else if(this.documentSegments){
      // group report
      payload.jobs = this.jobs;
      payload.pages = [this.documentSegments[0].segmentNumber];
      //this.documentSegments.map(val => {payload.pages.push(val.segmentNumber)});
      this.store.dispatch(new SendManyPagesToStudio(payload));
    }else{
      // job report
      payload.pages = [];
      this.selectedJob.documentSegments.map(val => {payload.pages.push(val.segmentNumber)});
      this.store.dispatch(new SendPagesToStudio(payload));
    }
    setTimeout(val => this.complete = true,500);
  }

  getModalTitle():string{
    let title = "";

    if(this.selectedDocumentSegment){
      title = `${this.selectedDocumentSegment.segmentIdentifier} ${this.selectedDocumentSegment.segmentNumber}`;
    }else if(this.documentSegments){
      // group report
      let segment = this.documentSegments[0];
      title = `${segment.segmentIdentifier} ${segment.segmentNumber} for all Regions`;
    }else{
      // job report
      title = `Region ${this.selectedJob.campaignRegions[0].name}`;
    }

    return title;
  }

  close():void{

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/send-to-studio-dialog/send-to-studio-dialog.component.ts